<template>
  <q-list separator>
    <q-item-label header>Gecmis Odemeler</q-item-label>

    <q-item v-for="purchase in purchases" :key="purchase.id">
      <q-item-section>
        <q-item-label
          ><span class="text-weight-light text-italic">
            {{ timetravel.humanReadableDate(purchase.timestamp) }}</span
          ></q-item-label
        >
      </q-item-section>

      <q-item-section>
        <q-item-label>
          <span class="text-weight">{{ purchase.subscriptionTitle }}</span>
        </q-item-label>
      </q-item-section>

      <q-item-section>
        <q-item-label>
          <span class="text-weight-medium">
            {{ mappers.paymentTypeMapper(purchase.paymentType) }}
            {{ purchase.price }} TL</span
          >
        </q-item-label>
      </q-item-section>

      <q-item-section side>
        <div>
          <q-btn
            color="red"
            dense
            icon="delete"
            @click="deletePurchase(purchase.id)"
          />
        </div>
      </q-item-section>
    </q-item>
  </q-list>
</template>
<script>
import { ref, onMounted, inject } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { useQuasar } from 'quasar'
import * as timetravel from '../../utils/timetravel'
import * as mappers from '../../utils/mapper'
import * as notify from '../../utils/notification'
import * as eventNames from '../../utils/events'
export default {
  props: {
    customerId: String,
  },
  setup() {
    const $q = useQuasar()
    const purchases = ref({})
    const route = useRoute()
    const customerId = route.path.split('/').pop()
    const emitter = inject('emitter')
    emitter.on(eventNames.REFRESH_CUSTOMER, () => {
      getPurchases()
    })
    const getPurchases = () => {
      axios.get(`/customers/${customerId}/purchase`).then((response) => {
        purchases.value = response.data
      })
    }

    const deletePurchase = (noteId) => {
      axios
        .delete(`/purchase/${noteId}`)
        .then(() => {
          $q.notify(notify.success('Odeme basariyla silindi.'))
          getPurchases()
        })
        .catch(() => {
          $q.notify(notify.warning('Odeme silinemedi.'))
        })
    }

    onMounted(() => {
      getPurchases()
    })

    return {
      purchases,
      timetravel,
      mappers,
      getPurchases,
      deletePurchase,
    }
  },
}
</script>
